export default {
  path: '/login',
  name: 'login',
  component: () => import('../views/auth/Login.vue'),
  meta: {
    layout: 'empty',
    public: true
  }
}